export const CAT = [
  {
    id: "01",
    name: "General",
  },
  {
    id: "02",
    name: "SOP",
  },
  {
    id: "03",
    name: "DM",
  },
  {
    id: "04",
    name: "CO",
  },
  {
    id: "05",
    name: "SA",
  },
  {
    id: "06",
    name: "MW",
  },
  {
    id: "07",
    name: "RA",
  },
  // {
  //   id: "09",
  //   name: "Other",
  // },
];

export const CAT_OBJ = {
  "01": "General",
  "02": "SOP",
  "03": "DM",
  "04": "CO",
  "05": "SA",
  "06": "MW",
  "07": "RA",
};

export const CAT_FILTER = [
  {
    text: "CO",
    value: ["cat", "=", "04"],
  },
  {
    text: "DM",
    value: ["cat", "=", "03"],
  },
  {
    text: "General",
    value: ["cat", "=", "01"],
  },
  {
    text: "MW",
    value: ["cat", "=", "06"],
  },
  {
    text: "SA",
    value: ["cat", "=", "05"],
  },
  {
    text: "SOP",
    value: ["cat", "=", "02"],
  },
  {
    text: "RA",
    value: ["cat", "=", "07"],
  },
];

export const TYPE_INTERNAL = [
  {
    id: "1",
    name: "Lecture",
  },
  {
    id: "2",
    name: "Self-Training",
  },
  {
    id: "3",
    name: "OJT",
  },
  { id: "9", name: "Other" },
];

export const TYPE_EXTERNAL = [
  {
    id: "4",
    name: "Attended a Training/Conference/Workshop/Class",
  },
  {
    id: "5",
    name: "DVD/Online Video/WebX",
  },
  { id: "9", name: "Other" },
];

export const TYPE = [
  {
    id: "1",
    name: "Lecture",
  },
  {
    id: "2",
    name: "Self-Training",
  },
  {
    id: "3",
    name: "OJT",
  },
  {
    id: "4",
    name: "Attended a Training/Conference/Workshop/Class",
  },
  {
    id: "5",
    name: "DVD/Online Video/WebX",
  },
  { id: "6", name: "SOP Read" },
  { id: "9", name: "Other" },
];

export const TYPE_OBJ = {
  1: "Lecture",
  2: "Self-Training",
  3: "OJT",
  9: "Other",
};

export const TYPE_OBJ_EXTERNAL = {
  4: "Attended a Training/Conference/Workshop/Class",
  5: "DVD/Online Video/WebX",
  9: "Other",
};

export const PROVIDER = [
  {
    id: "1",
    name: "Internal",
  },
  {
    id: "2",
    name: "External",
  },
  {
    id: "9",
    name: "Other",
  },
];

export const NOTIFICATION = [
  {
    id: -1,
    name: "직접 입력",
  },
  {
    id: 0,
    name: "정시",
  },
  {
    id: 5,
    name: "5분 전",
  },
  {
    id: 10,
    name: "10분 전",
  },
  {
    id: 15,
    name: "15분 전",
  },
  {
    id: 30,
    name: "30분 전",
  },
  {
    id: 60,
    name: "1시간 전",
  },
  {
    id: 120,
    name: "2시간 전",
  },
  {
    id: 180,
    name: "3시간 전",
  },
  {
    id: 720,
    name: "12시간 전",
  },
  {
    id: 1440,
    name: "1일 전",
  },
  {
    id: 10080,
    name: "1주일 전",
  },
];
